exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.required-feedback[data-v-2c27b4d1]{width:100%;margin-top:.25rem;font-size:.875em;color:#dc3545\n}", ""]);

// exports
